import { BaseModel } from '@tcc-mono/shared/data-access';

export class Vehicle extends BaseModel {
  id: number;
  relation_id: number;
  relation_name: string;
  license_plate: string;
  surface: number;
}
